export const baseUrl = "https://dev-api-aipay.appinsnap.com/";
